export default {
  // 基础通用=Basic general purpose
  base_common: {
    workbench: 'Portal',
    library: 'File Library',
    memo: 'Memo',
    approval: 'Approval center',
    project: 'Project collaboration',
    knowledge: 'Knowledge base',
    knowledgeDoc: 'Knowledge document',
    email: 'Email management',
    report: 'Data report',
    attendance: 'Attendance Center',
    salary: 'Smart compensation',
    task: 'Task',
    schedule: 'Schedule',
    determine: 'Confirm',
    save: 'Save',
    cancel: 'Cancel',
    submit: 'Submit',
    down: 'Download',
    import: 'Import',
    export: 'Export',
    picture: 'Picture',
    video: 'Video',
    audio: 'Audio',
    file: 'Document',
    nothing: 'None ',
    newbuilt: 'New',
    remove: 'Remove',
    add: 'Add',
    adjunction: 'Add',
    copy: 'Copy',
    open: 'Open',
    query: 'Query',
    previews: 'Previews',
    yes: 'Yes',
    no: 'No',
    on: 'On',
    off: 'Off',
    rename: 'Rename',
    comment: 'Communication',
    relation: 'Association',
    member: 'Member',
    addMember: 'Add member',
    sharedMembers: 'Shared members',
    look: 'Look ',
    set: 'Set',
    close: 'Close',
    search: 'Search',
    select: 'Select',
    selectAll: 'Select all',
    to: 'To',
    stopUsing: 'Stop Using',
    disable: 'Disable',
    enable: 'Enable',
    year: 'Year',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    day2: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    ge: 'Pieces',
    tiao: 'Item',
    yuan: 'Yuan',
    tips: 'Tips',
    mustFill: 'Required',
    required: 'Required',
    norecoverable: 'Cannot be recovered after deletion',
    determineDelete: 'Are you sure you want to delete it',
    print: 'Print',
    upload: 'Upload',
    uploadFiles: 'UploadFiles',
    size: 'Size',
    status: 'Status',
    administrator: 'Administrator',
    time: 'Time',
    createTime: 'CreateTime',
    create_by: 'Creator',
    modify_time: 'Modification time',
    start_time: 'Start time',
    end_time: 'End time',
    modify_by: 'Modified by',
    operation: 'Operation',
    approvalTypeAfterReject: 'Approval type after reject',
    spread: 'Expand',
    retract: 'Retract',
    man: 'Man',
    woman: 'Woman',
    person: 'Person',
    content: 'Content',
    visibleRange: 'Visible range',
    networkFailPleaseTryAgain: 'Network exception, please try again later',
    SelectDataMinOne: 'Select at least one piece of data',
    uncultivated: 'The function has not been developed yet',
    roledepemp: ' Member, Department, role',
    custom: 'Custom',
    sso: 'Sign on',
    page404: 'Sorry, the page you visited does not exist',
    local: 'Local',
    // 20210715
    taskYdt: 'To do task',
    tip: {
      deleteTip: 'Cannot be recovered after deletion'
    },
    message: {
      addSuccess: 'Added successfully',
      editorSuccess: 'Edit succeeded',
      copySuccess: 'Copy succeeded',
      moveSuccess: 'Move successful',
      success: 'Saved successfully',
      upload: 'Upload succeeded',
      delete: 'Deleted successfully',
      operate: 'Operation successful',
      send: 'Sent successfully',
      perform: 'Execution succeede',
      playFail: 'Execution failure',
      import: 'Import succeeded',
      timeRange: 'Please select start time and deadline for range',
      refushTip: 'Data has been updated, please refresh the page'
    },
    placeholder: {
      all: 'All',
      selected: 'Selected',
      input: 'Please Input',
      select: 'Please select',
      select_must: 'Please select (required)',
      pwd: 'Please input a password',
      newpwd: 'Please enter a new password',
      confirmpwd: 'Confirm password',
      code: 'Please enter the verification code',
      phone: 'Please enter your mobile phone number',
      keywords: 'Please enter keywords',
      chooseDate: 'Select date',
      chooseTime: 'Select the time',
      chooseYM: 'Select month and year',
      chooseDatetime: 'Select date time',
      ctrlEnter: 'Comment content (Ctrl + enter send)',
      matrixName: 'Please input a matrixName',
      jobPositionName: 'Please enter the job title'
    },
    error: {
      empty: 'Cannot be empty',
      noAuthority: 'No authority',
      phone: 'Mobile phone number format error',
      phone_empty: 'Mobile phone number cannot be empty',
      name_empty: 'The name cannot be empty',
      pwd: 'Wrong password format',
      pwd_empty: 'Password cannot be empty',
      pwd_atypism: 'The two password inputs are inconsistent',
      pwd_accordwith: 'The password must meet the requirements',
      code: 'Verification code error',
      code_empty: 'Verification code cannot be empty',
      PwdPopover: 'The minimum password length is at least',
      PwdPopover0: 'Characters',
      PwdPopover1: 'Characters and must contain alphabetic and numeric characters',
      PwdPopover2: 'Characters and must contain letters, numbers, and special characters',
      PwdPopover3: 'Characters and must contain numbers and upper and lower case letters',
      PwdPopover4:
        'Characters and must contain numbers, uppercase and lowercase letters, and special characters',
      fileSize: 'The size of a single file cannot exceed 100m',
      fileSize2: 'The file size must not exceed 200MB',
      fileSize20: 'The file size must not exceed 20MB',
      formatError: 'Format error',
      formatError2: 'Upload format error',
      scaleError: 'Scale error',
      outOfInputRange: 'Out of input range',
      enterMin: 'Enter the minimum value',
      enterMax: 'Enter the maximum value',
      visibleRange_empty: 'Visible range cannot be empty'
    },
    screenInfo: {
      // 筛选信息=Filtering information
      asc: 'Ascending order',
      desc: 'Descending order',
      Filled: 'Completed',
      notFilled: 'Not filled in',
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This week',
      lastWeek: 'Last week',
      pastSevenDays: 'Last seven days',
      past30Days: 'Last 30 days',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      thisQuarter: 'This quarter',
      lastQuarter: 'Last quarter',
      thisYear: 'This year',
      lastYear: 'last year',
      timeRange: 'Range'
    },
    weeks: {
      Mon: 'Monday',
      Tues: 'Tuesday',
      Wed: 'Wednesday',
      Thur: 'Thursday',
      Fri: 'Friday',
      Sat: 'Saturday',
      Sun: 'Sunday'
    },
    weeksTwo: {
      Mon: 'Monday',
      Tues: 'Tuesday',
      Wed: 'Wednesday',
      Thur: 'Thursday',
      Fri: 'Friday',
      Sat: 'Saturday',
      Sun: 'Sunday'
    },
    weeksThree: {
      Mon: 'Monday',
      Tues: 'Tuesday',
      Wed: 'Wednesday',
      Thur: 'Thursday',
      Fri: 'Friday',
      Sat: 'Saturday',
      Sun: 'Sunday'
    },
    userInfo: {
      name: 'Name',
      gender: 'Gender',
      department: 'Department',
      company: 'Company',
      superior: 'Superior',
      landline: 'Landline',
      phone: 'Mobile phone',
      tel: 'Telephone',
      email: 'Email',
      birthday: 'Birthday',
      emid: 'Job number',
      enable: 'State',
      postName: 'Post',
      roleName: 'Role',
      account: 'Account number',
      area: 'Area',
      address: 'Address',
      material: 'Data',
      activated: 'Activated',
      notActive: 'Not active',
      hobbie: ''
    },
    comments: {
      moreCommon: 'More comments',
      backTop: 'Back to the top',
      expression: 'Expression',
      send: 'Send',
      message_empty: 'You cannot send blank comments'
    },
    members: {
      selectMember: 'Select members',
      selected: 'Selected',
      includingSubordinateDepartment: 'Include subordinate departments',
      member: 'Member',
      department: 'Department',
      role: 'Role',
      dynamicParameters: 'Dynamic parameter',
      current_login_personnel: 'Current members',
      current_main_department: 'Current department'
    },
    preview: {
      image: 'Picture',
      rotate: 'Left rotation',
      rotate1: 'Right rotation',
      magnif: 'Enlarge',
      shrink: 'Shrink',
      dpwnload: 'Download',
      fullScreen: 'View in full screen',
      exitfull: ''
    },
    insufficientAuth: 'Insufficient authority, please contact system administrator',
    gobackBaseModule: 'Back to basic module',
    action: {
      pause: 'Suspend',
      archive: 'File',
      release: 'Release',
      undo: 'Revoke',
      transferleader: 'Transfer manager',
      share: 'Share',
      retreattotheopenseapool: 'Return to high seas',
      convert: 'Rransformation',
      pickup: 'Receive',
      allocate: 'Allocate',
      move: 'Move',
      batchmodification: 'Batch modification',
      recovery: 'Recovery',
      managefolders: 'Manage folders',
      setupadministrator: 'Set up administrator',
      setpermissions: 'Set permissions',
      completelydelete: 'Delete completely',
      recoverymemo: 'Recall notes',
      reset: 'Reset',
      enabledisable: 'Enable / disable',
      accountbinding: 'Account binding',
      processapproval: 'Process approval',
      modifyapprover: 'Revise approver'
    },
    image: {
      fill: 'Fill',
      adapt: 'Adapt',
      stretch: 'Stretching',
      tiled: 'Tile',
      centere: 'Center'
    },
    data: 'Data'
  }
}
